<script>
import { apiCheckLogin, apiUseApiAuth } from '@/api/user'
import { apiGetContainers } from '@/api/optimize'
import { apiBindLineBotBath } from '@/api/notify'

export default {
  name: 'BindLineGroup',
  data() {
    return {
      dialog: false,
      bind_line_bot_res_header: [
        { text: '組織名稱', value: 'org_name', sortable: true },
        { text: '容器名稱', value: 'container_name', sortable: false },
        { text: '狀態', value: 'status', sortable: false, align: 'center' },
        { text: '描述', value: 'message', sortable: false },
      ],
      bind_line_bot_res: [],
      org_list: [{ text: '請選擇組織', value: '' }],
      selected_list: [],
      table_headers: [
        { text: '組織名稱', value: 'org_name', sortable: false },
        { text: '容器名稱', value: 'container_name', sortable: false },
      ],
      containers: [],
      container_name: {},
    }
  },
  created() {
    this.$store.commit('setIsShowDrawer', false)
    this.getOrgList()
  },
  methods: {
    async getOrgList() {
      try {
        const res = (await apiCheckLogin()).data
        if (res.code === 200) {
          this.org_list = res.data.organizations.reduce((acc, cur) => {
            acc[cur.org_id] = cur.org_name
            return acc
          }, {})

          for (const key in this.org_list) {
            if (await this.checkUseApiAuth(key)) {
              await this.getContainers(key)
            }
          }
        }
      } catch (error) {
        console.error('getOrgList() :', error)
        this.$router.push('/auth')
      }
    },
    async checkUseApiAuth(org_id) {
      try {
        const payload = {
          org: org_id,
          api: [{ method: 'POST', url: '/notify/register/linebot' }],
        }
        const res = await apiUseApiAuth(payload)
        if (res[0].enable) {
          return true
        }
        throw new Error('暫無權限')
      } catch (error) {
        console.error('checkUseApiAuth() :', error)
        return false
      }
    },
    async getContainers(org_id) {
      try {
        const res = (await apiGetContainers(org_id)).data
        if (res.code === 200) {
          const single_org_containers = res.data
            .filter((item) => !item.notify_infos?.length)
            .map((item) => ({
              org_name: this.org_list[item.org_id],
              org_id: item.org_id,
              container_name: item.name,
              container_id: item.id,
            }))

          this.containers.push(...single_org_containers)
          this.selected_list = [...this.containers]
          return
        }

        throw new Error('取得可綁定容器資料失敗')
      } catch (error) {
        console.error('getContainers() :', error)
        this.$root.vtoast.show({
          color: 'error',
          message: '取得可綁定容器資料失敗',
        })
      }
    },
    async bindLineBot() {
      if (!this.selected_list.length) {
        return this.$root.vtoast.show({
          color: 'error',
          message: '請先選擇要綁定的容器',
        })
      }

      const promises = []
      for (const [org_id, org_name] of Object.entries(this.org_list)) {
        const some_one_org_containers = []
        this.selected_list.forEach((item) => {
          if (item.org_name === org_name) {
            some_one_org_containers.push(item)
          }
        })

        if (some_one_org_containers.length) {
          const params = { org: org_id }
          const payload = {
            notify_platform: 'linebot',
            container_ids: some_one_org_containers.map((item) => item.container_id),
            token: this.$route.query['line-group-token'],
          }
          promises.push(apiBindLineBotBath(params, payload))
        }
      }

      const res = await Promise.allSettled(promises)
      const show_res = []
      res.forEach((item) => {
        if (item.status === 'rejected') {
          item.reason.payload.container_ids.forEach((container) => {
            show_res.push({
              org_name: this.org_list[item.reason.params.org],
              container_name: this.containers.find((item) => item.container_id === container).container_name,
              status: item.status,
              message: item.reason.message,
            })
          })
        } else if (item.status === 'fulfilled') {
          item.value.payload.container_ids.forEach((container) => {
            show_res.push({
              org_name: this.org_list[item.value.params.org],
              container_name: this.containers.find((item) => item.container_id === container).container_name,
              status: item.status,
              message: '',
            })
          })
        }
      })
      this.bind_line_bot_res = show_res
      this.dialog = true
    },
  },
}
</script>

<template>
  <div>
    <v-sheet class="mb-3 px-1 py-4" color="grey lighten-4" elevation="4" height="64">
      <h1 class="v-toolbar__title font-weight-regular ml-4">綁定 LINE 群組</h1>
    </v-sheet>
    <v-data-table
      v-model="selected_list"
      show-select
      hide-default-footer
      class="pa-4"
      item-key="container_id"
      :headers="table_headers"
      :items="containers"
    >
      <template #top>
        <div class="d-flex justify-end align-center">
          <v-btn class="white--text" color="primary" @click="bindLineBot()" v-text="'綁定'" />
        </div>
      </template>
      <template #[`item.container_name`]="{ item }">
        <router-link :to="`/${item.org_id}/setting/containers/${item.container_id}/edit`">
          {{ item.container_name }}
        </router-link>
      </template>
      <template #no-data>
        <v-sheet class="d-flex align-center justify-center" height="200">
          <p class="text-h6 grey--text" v-text="'尚未有可綁定的容器'" />
        </v-sheet>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title class="white--text primary" v-text="'綁定結果'" />
        <v-card-text class="pa-5">
          <v-data-table :headers="bind_line_bot_res_header" :items="bind_line_bot_res" hide-default-footer>
            <template #[`item.status`]="{ item }">
              <v-chip
                text-color="white"
                :color="item.status === 'rejected' ? 'error' : 'success'"
                v-text="item.status === 'rejected' ? '綁定失敗' : '綁定成功'"
              />
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="justify-end pa-5">
          <v-btn
            color="primary"
            @click="
              $router.replace(`${selected_list[0].org_id}/setting/containers/${selected_list[0].container_id}/edit`)
            "
            v-text="'我知道了'"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
